import { render, staticRenderFns } from "./ConfiguracoesMensagemBoasVindas.vue?vue&type=template&id=476b5bae"
import script from "./ConfiguracoesMensagemBoasVindas.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesMensagemBoasVindas.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracoesMensagemBoasVindas.vue?vue&type=style&index=0&id=476b5bae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports